import React from 'react';
import { useField } from 'react-final-form';

import { MenuItem, TextField } from '@mui/material';

const MODERN_SANS = '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif';
const BOOK_SANS = 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif';
const ORGANIC_SANS = 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif';
const GEOMETRIC_SANS = 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif';
const HEAVY_SANS =
  'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif';
const ROUNDED_SANS =
  'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif';
const MODERN_SERIF = 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif';
const BOOK_SERIF = '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif';
const MONOSPACE = '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace';

// Based on https://modernfontstacks.com/#font-stacks
export const DEFAULT_FONT_FAMILIES = [
  { value: MODERN_SANS, label: 'Modern sans' },
  { value: BOOK_SANS, label: 'Book sans' },
  { value: ORGANIC_SANS, label: 'Organic sans' },
  { value: GEOMETRIC_SANS, label: 'Geometric sans' },
  { value: HEAVY_SANS, label: 'Heavy sans' },
  { value: ROUNDED_SANS, label: 'Rounded sans' },
  { value: MODERN_SERIF, label: 'Modern serif' },
  { value: BOOK_SERIF, label: 'Book serif' },
  { value: MONOSPACE, label: 'Monospace' },
] as const;
export const BASE_FONT_FAMILY = DEFAULT_FONT_FAMILIES[0];

const fonts = [
  {
    value: 'inherit',
    label: 'Match email settings',
  },
  ...DEFAULT_FONT_FAMILIES,
];

type Props = {
  label: string;
  name: string;
};
export default function FontFamilyInput({ label, name }: Props) {
  const {
    input: { value, onChange },
  } = useField(name);

  return (
    <TextField
      select
      variant="standard"
      label={label}
      name={name}
      onChange={(ev) => {
        onChange(ev.target.value);
      }}
      value={value}
    >
      {fonts.map((option) => (
        <MenuItem key={option.value} value={option.value} sx={{ fontFamily: option.value }}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
}
